import { prepareTextPanelsList } from 'engage/routes/CompanySettings/components/TextPanels/utils';
import CmsAPI from '../../common/apis/CmsAPI';
import { FOLDER_USER_ROLE, STORY_USER_RELATION } from '../constants/UserRoles';
import VideoService from '../service/VideoService';

const EDITOR_PERMISSIONS = {
  allowedScenes: [],
  readStory: true,
  updateStory: true,
};

export const getUserPermission = async (videoId, role) => {
  if (role !== STORY_USER_RELATION.VIEWER.TYPE) {
    return EDITOR_PERMISSIONS;
  } else {
    const permissions = { readStory: false, updateStory: false, allowedScenes: [] };
    const response = await VideoService.getStoryPermissionsMe(videoId);
    if (response) {
      if (response.hasOwnProperty('scenes')) {
        permissions.allowedScenes = [...new Set(response.scenes.map(item => item.sceneId))];
      }
      if (response.hasOwnProperty('story')) {
        permissions.readStory = response.story.find(item => item.action === 'read') !== undefined ?? false;
        permissions.updateStory = response.story.find(item => item.action === 'update') !== undefined ?? false;
      }
    }
    return permissions;
  }
};

export const getUserRole = async (video, user, userCompanyId, isApprovalFlowEnabled, isReviewerUser) => {
  if (user) {
    /**
     * Editor is available for the currently loggen in case user:
    - is a video owner;
    - is a reviewer in company with enabled approval flow feature;
    - is a folder owner or folder participant with editing permission;
    */
    if (user.username === video.author.username) {
      return STORY_USER_RELATION.OWNER.TYPE;
    }

    // Company ID is not in the user object add a request
    if (isApprovalFlowEnabled && isReviewerUser) {
      return STORY_USER_RELATION.ROLE.TYPE;
    }

    if (video.folder) {
      const { result } = await CmsAPI.getFolder(video.folder);
      if (result) {
        if (result.owner?.username === user.username) {
          return STORY_USER_RELATION.FOLDER_OWNER.TYPE;
        }

        const currentLoggedInUserInFolder = result?.users?.find(item => item.username === user.username);
        if (currentLoggedInUserInFolder?.folderRole === FOLDER_USER_ROLE.EDITOR.TYPE) {
          if (result.editingEnabled) {
            return STORY_USER_RELATION.FOLDER_ADVANCED_EDITOR.TYPE;
          }
          return STORY_USER_RELATION.FOLDER_EDITOR.TYPE;
        }
      }
    }
  }

  return STORY_USER_RELATION.VIEWER.TYPE;
};

export const isVideoPathIsHls = (id, src) => {
  if (!id) {
    return src?.includes('.m3u8');
  }
  if (src?.length) {
    const extension = src
      .split('?')[0]
      .split(`${id}`)
      .slice(1)
      ?.find(item => item.includes('.'))
      ?.split('.')[1];
    return extension === 'm3u8';
  }
};

export const assignFontsForConfig = async (videoConfig) => {
  const fonts = videoConfig?.fonts;
  if (!fonts || !Array.isArray(fonts)) {
    return videoConfig;
  }
  const copiedConfig = structuredClone(videoConfig);
  for (const key in copiedConfig) {
    if (key !== 'fonts') {
      if (Array.isArray(copiedConfig[key])) {
        copiedConfig[key].forEach((item) => {
          if (item?.hasOwnProperty('fontId')) {
            item['font'] = fonts.find(font => String(font.id) === String(item['fontId']));
          }
          for (const subKey in item) {
            if (typeof item[subKey] === 'object' && item[subKey] !== null) {
              if (item[subKey]?.hasOwnProperty('fontId')) {
                item[subKey]['font'] = fonts.find(font => String(font.id) === String(item[subKey]['fontId']));
              }
            }
          }
        })
      } else {
        if (copiedConfig[key]?.hasOwnProperty('fontId')) {
          copiedConfig[key]['font'] = fonts.find(font => String(font.id) === String(copiedConfig[key]['fontId']));
        }
      }
    }
  }
  if (copiedConfig?.textPanelTemplates?.length) {
    copiedConfig.textPanelTemplates = await prepareTextPanelsList(copiedConfig.textPanelTemplates);
  }
  return copiedConfig;
}